"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RootCloseWrapper = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_dom_1 = __importDefault(require("react-dom"));
var add_event_listener_1 = require("./utils/add-event-listener");
var owner_document_1 = require("./utils/owner-document");
var dom_helpers_1 = require("../util/dom-helpers");
function isLeftClickEvent(event) {
  return event.button === 0;
}
function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var RootCloseWrapper = /** @class */function (_super) {
  __extends(RootCloseWrapper, _super);
  function RootCloseWrapper(props) {
    var _this = _super.call(this, props) || this;
    _this.getWrappedDOMNode = function () {
      // We can't use a ref to identify the wrapped child, since we might be
      // stealing the ref from the owner, but we know exactly the DOM structure
      // that will be rendered, so we can just do this to get the child's DOM
      // node for doing size calculations in OverlayMixin.
      var node = react_dom_1.default.findDOMNode(_this);
      return _this.props.noWrap ? node : node.firstChild;
    };
    _this.bindRootCloseHandlers = function () {
      var doc = owner_document_1.ownerDocument(_this);
      _this._onDocumentMouseListener = add_event_listener_1.addEventListener(doc, _this.props.event, _this.handleDocumentMouse, true);
      _this._onDocumentKeyupListener = add_event_listener_1.addEventListener(doc, 'keyup', _this.handleDocumentKeyUp, true);
    };
    _this.handleDocumentMouse = function (e) {
      var _a;
      if (dom_helpers_1.contains(_this._childRef, e.target)) {
        return;
      }
      if (_this.props.disabled || isModifiedEvent(e) || !isLeftClickEvent(e)) {
        return;
      }
      (_a = _this.props) === null || _a === void 0 ? void 0 : _a.onRootClose(e);
    };
    _this.handleDocumentKeyUp = function (e) {
      if (e.keyCode === 27 && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };
    _this.unbindRootCloseHandlers = function () {
      if (_this._onDocumentMouseListener) {
        _this._onDocumentMouseListener.remove();
      }
      if (_this._onDocumentKeyupListener) {
        _this._onDocumentKeyupListener.remove();
      }
    };
    _this.setChildRef = function (node) {
      _this._childRef = node;
    };
    _this.handleDocumentMouse = _this.handleDocumentMouse.bind(_this);
    _this.handleDocumentKeyUp = _this.handleDocumentKeyUp.bind(_this);
    return _this;
  }
  RootCloseWrapper.prototype.componentDidMount = function () {
    this.bindRootCloseHandlers();
  };
  RootCloseWrapper.prototype.componentWillUnmount = function () {
    this.unbindRootCloseHandlers();
  };
  RootCloseWrapper.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      noWrap = _a.noWrap,
      children = _a.children;
    var child = react_1.default.Children.only(children);
    if (noWrap) {
      return react_1.default.cloneElement(child, {
        ref: function ref(node) {
          // Keep your own reference
          _this._childRef = node;
          // Call the original ref, if any
          var ref = child.ref;
          if (typeof ref === 'function') {
            ref(node);
          }
        }
      });
    }
    return react_1.default.createElement("div", {
      ref: this.setChildRef
    }, child);
  };
  RootCloseWrapper.propTypes = {
    onRootClose: prop_types_1.default.func,
    disabled: prop_types_1.default.bool,
    noWrap: prop_types_1.default.bool,
    event: prop_types_1.default.oneOf(['click', 'mousedown'])
  };
  RootCloseWrapper.defaultProps = {
    event: 'click'
  };
  return RootCloseWrapper;
}(react_1.default.Component);
exports.RootCloseWrapper = RootCloseWrapper;